import { useEffect, useRef } from 'react';

import { PageLayout } from '~/components/unified/PageLayout';

import { PageWrapper } from './PageWrapper';
import { List, ListFooter, ListHeader } from './ProspectList';
import { useProspector } from './useProspector';

export function Listing() {
  const [state, send] = useProspector();
  const {
    prospects,
    deselections,
    totalProspects,
    previousTotalCompanies,
    totalCompanies,
    previousTotalProspects,
    pageEnd,
    pageStart,
    hasNextPage,
    hasPreviousPage,
    loadingPage,
  } = state.context;

  const handleSelectAll = () => send('SELECT_ALL');
  const handleSelectAllPage = () => send('SELECT_ALL_PAGE');
  const handleDeselectAll = () => send('DESELECT_ALL');
  const handleSelectItem = (id: string) => send('SELECT_PROSPECT', { id });
  const handleDeselectItem = (id: string) => send('DESELECT_PROSPECT', { id });

  const bodyRef = useRef<HTMLDivElement>(null);

  const selectAllChecked: boolean =
    state.context.selectAll || state.context.selectAllPage;

  const selectedProspects = selectAllChecked
    ? prospects.map((p) => p.id).filter((id) => !deselections.includes(id))
    : state.context.selections;

  useEffect(() => {
    if (bodyRef.current) {
      bodyRef.current.scrollTop = 0;
    }
  }, [loadingPage, pageEnd, pageStart]);

  return (
    <PageWrapper>
      <PageLayout.Body ref={bodyRef}>
        <PageLayout.Content className="space-y-4">
          <ListHeader
            hasNextPage={hasNextPage}
            hasPreviousPage={hasPreviousPage}
            onNextPage={() => send('NEXT_PAGE')}
            onPreviousPage={() => send('PREVIOUS_PAGE')}
            pageEnd={pageEnd}
            pageStart={pageStart}
            previousTotalCompanies={previousTotalCompanies}
            previousTotalProspects={previousTotalProspects}
            totalCompanies={totalCompanies}
            totalProspects={totalProspects}
          />
          <List
            isLoading={loadingPage}
            onDeselectItem={handleDeselectItem}
            onSelectItem={handleSelectItem}
            prospects={prospects}
            selectedProspects={selectedProspects}
          />
        </PageLayout.Content>
      </PageLayout.Body>
      <ListFooter
        onDeselectAll={handleDeselectAll}
        onSelectAll={handleSelectAll}
        onSelectAllPage={handleSelectAllPage}
        selectAllChecked={selectAllChecked}
        selectedProspectsCount={
          state.context.selectAll
            ? state.context.totalProspects - deselections.length
            : state.context.selections.length
        }
        totalProspects={totalProspects}
      />
    </PageWrapper>
  );
}
